import React from 'react';
import './hooks.css';

export default function HookStatusPill({ status }) {
    const approved = status === 'approved';
    return (
        <span className={`hk-pill ${approved ? 'hk-pill-approved' : 'hk-pill-draft'}`}>
            {approved ? 'Approved' : 'Draft'}
        </span>
    );
}
